@if (!match.profile.disableTeamFlyby) {
  <app-flyby #teamFlyby [direction]="teamDirection">
    @if (match.winningTeam; as $team) {
      @if ($team.hasLogo) {
        <img class="team-name" [src]="$team.logoPath" [alt]="$team.name">
      } @else {
        <div class="team-name team-{{$team.type}}">{{$team.name}}</div>
      }
    } @else {
      <div class="team-name">Tied Score!!!</div>
    }
  </app-flyby>
}

<app-live-scoreboard class="view"
  [class.active]="showScore"
 />

<app-live-slate class="view"
  [class.active]="showSlate"
 />

@if (match.guesses.game) {
  <app-live-guesses class="view"
    [class.active]="showGuesses"
   />
}

@if (match.themeSlides.enabled) {
  <app-live-themes class="view"
    [class.active]="showThemes"
   />
}

<!--
FULL-SCREEN BUTTON
-->
@if (fullScreen.canEnter) {
  <button
    class="fullscreen-button btn text-light"
    (click)="enterFullScreen()"
    >
    <i class="bi-fullscreen"></i>&nbsp;&nbsp;Double-Click
  </button>
}
